
import { Component, Prop, Vue, Watch } from "vue-property-decorator";
import store from "@/store/index";
import { ViewItem, Gizmo, ItemType } from "@/core/constants/gizmo";
import { itemMap } from "@/core/constants";
import { Vector2D } from "@/core/physics";
@Component
export default class ItemZone extends Vue {
  get currentMode() {
    return store.state.module1.currentMode;
  }

  private length = 48;
  private currentItem: ItemType = "select";

  @Watch("currentItem")
  onCurrentItemChanged(val: ItemType, oldVal: ItemType) {
    store.commit.changeToolZoneCurrentItem(Gizmo.getViewItemByType(val));
  }

  readonly itemss: ViewItem[][] = Gizmo.itemss;

  onDragstart(item: ViewItem, event: DragEvent) {
    store.commit.changeDraggingItemOffset(new Vector2D(0, 0));
    store.commit.changeDraggingItem(item);
  }

  onDragend(item: ViewItem, event: DragEvent) {
    store.commit.changeDraggingItem(null);
  }
}
